import * as PIXI from "pixi.js";
import { FileExtension } from "../file/FileType";
/**
 * AtlasAssetLoader.ts
 */
export class AtlasAssetLoader {
    constructor(atlasUrl, atlasText, onComplete) {
        this.atlasText = atlasText;
        this.atlasUrl = atlasUrl;
        this.onComplete = onComplete;
        this.createLoader();
    }
    createLoader() {
        const imageUrls = this.findAtlasAssets(this.atlasText, this.atlasUrl);
        PIXI.Assets.load(imageUrls).then((records) => {
            this.handleLoaderComplete(records);
        });
    }
    handleLoaderComplete(records) {
        this.onComplete(records);
    }
    findAtlasAssets(atlasData, atlasUrl) {
        //Break the atlas into lines, then find the lines containing an image filename;
        const lines = atlasData.match(/^.*$/mg);
        const imageNames = lines.filter(line => line.toLowerCase().indexOf(FileExtension.PNG) > -1 || line.toLowerCase().indexOf(FileExtension.WEBP) > -1);
        const atlasPath = atlasUrl.substring(0, atlasUrl.lastIndexOf("/") + 1);
        return imageNames.map(imageName => {
            return { alias: imageName, url: atlasPath + imageName, src: atlasPath + imageName };
        });
    }
}
//# sourceMappingURL=AtlasAssetLoader.js.map